export const arrayPlates = [
        {
          name: 'Pasta with tomato sauce',
          index: 'pasta-al-pomodoro',
          bgImage: require('./assets/piatto-bg-1.jpg'),
          thumbImage: require('./assets/130x130/pasta-al-pomodoro-thumb.png'),
          srcImage: require('./assets/680x680/pasta-al-pomodoro.png')
        },
        {
          name: 'Lasagna',
          index: 'lasagna',
          bgImage: require('./assets/piatto-bg-2.jpg'),
          thumbImage: require('./assets/130x130/lasagna-thumb.png'),
          srcImage: require('./assets/680x680/lasagna.png')
        },
        {
          name: 'Frittata',
          index: 'frittata',
          bgImage: require('./assets/piatto-bg-1.jpg'),
          thumbImage: require('./assets/130x130/frittata-thumb.png'),
          srcImage: require('./assets/680x680/frittata.png')
        },
        {
          name:'Pasta with beans',
          index: 'pasta-e-fagioli',
          bgImage: require('./assets/piatto-bg-2.jpg'),
          thumbImage: require('./assets/130x130/pasta-e-fagioli-thumb.png'),
          srcImage: require('./assets/680x680/pasta-e-fagioli.png')
        },
        {
          name:'Risotto milanese',
          index: 'risotto-alla-milanese',
          bgImage: require('./assets/sfondi-piatti/sfondo-risotto-alla-milanese.png'),
          thumbImage: require('./assets/130x130/risotto-alla-milanese.png'),
          srcImage: require('./assets/680x680/risotto-alla-milanese.png')
        },
        {
          name:'Farmer’s soup',
          index: 'zuppa-contadina',
          bgImage: require('./assets/sfondi-piatti/sfondo-zuppa-contadina.png'),
          thumbImage: require('./assets/130x130/zuppa-contadina.png'),
          srcImage: require('./assets/680x680/zuppa-contadina.png')
        },
        {
          name:'Vegetable couscous',
          index: 'cous-cous',
          bgImage: require('./assets/sfondi-piatti/sfondo-cous-cous.png'),
          thumbImage: require('./assets/130x130/cous-cous.png'),
          srcImage: require('./assets/680x680/cous-cous.png')
        },
        {
          name:'Herb-stuffed ravioli',
          index: 'tortellini-alle-erbe',
          bgImage: require('./assets/sfondi-piatti/sfondo-tortellini-alle-erbe.png'),
          thumbImage: require('./assets/130x130/tortellini-alle-erbe.png'),
          srcImage: require('./assets/680x680/tortellini-alle-erbe.png')
        },
        {
          name:"Soy noodles with shrimp and veggies",
          index: 'spaghetti-soia',
          bgImage: require('./assets/sfondi-piatti/sfondo-spaghetti-soia.png'),
          thumbImage: require('./assets/130x130/spaghetti-soia.png'),
          srcImage: require('./assets/680x680/spaghetti-soia.png')
        },
        
        {
          name:'Pasta with broccoli',
          index: 'pasta-e-broccoli',
          bgImage: require('./assets/sfondi-piatti/sfondo-pasta-e-broccoli.png'),
          thumbImage: require('./assets/130x130/pasta-e-broccoli.png'),
          srcImage: require('./assets/680x680/pasta-e-broccoli.png')
        },
        {
          name:'Rice and peas',
          index: 'riso-e-piselli',
          bgImage: require('./assets/sfondi-piatti/sfondo-riso-e-piselli.png'),
          thumbImage: require('./assets/130x130/riso-e-piselli.png'),
          srcImage: require('./assets/680x680/riso-e-piselli.png')
        },
        {
          name:"Sushi",
          index: 'sushi',
          bgImage: require('./assets/sfondi-piatti/sfondo-sushi.png'),
          thumbImage: require('./assets/130x130/sushi.png'),
          srcImage: require('./assets/680x680/sushi.png')
        },
        {
          name:'Hamburger',
          index: 'hamburger',
          bgImage: require('./assets/sfondi-piatti/sfondo-hamburger.png'),
          thumbImage: require('./assets/130x130/hamburger.png'),
          srcImage: require('./assets/680x680/hamburger.png')
        },
        {
          name:'Chicken breast',
          index: 'petto-di-pollo',
          bgImage: require('./assets/sfondi-piatti/sfondo-petto-di-pollo.png'),
          thumbImage: require('./assets/130x130/petto-di-pollo.png'),
          srcImage: require('./assets/680x680/petto-di-pollo.png')
        },
        {
          name:'Cod',
          index: 'merluzzo',
          bgImage: require('./assets/sfondi-piatti/sfondo-merluzzo.png'),
          thumbImage: require('./assets/130x130/merluzzo.png'),
          srcImage: require('./assets/680x680/merluzzo.png')
        },
        {
          name:'Veggie pie',
          index: 'tortini-di-verdure',
          bgImage: require('./assets/sfondi-piatti/sfondo-tortini-di-verdure.png'),
          thumbImage: require('./assets/130x130/tortini-di-verdure.png'),
          srcImage: require('./assets/680x680/tortini-di-verdure.png')
        },
        {
          name:"Tuscan baked beans",
          index: 'fagioli-all-uccelletto',
          bgImage: require('./assets/sfondi-piatti/sfondo-fagioli-all-uccelletto.png'),
          thumbImage: require('./assets/130x130/fagioli-all-uccelletto.png'),
          srcImage: require('./assets/680x680/fagioli-all-uccelletto.png')
        },
        {
          name:"Hummus with veggies",
          index: 'hummus-vegetale',
          bgImage: require('./assets/sfondi-piatti/sfondo-hummus-vegetale.png'),
          thumbImage: require('./assets/130x130/hummus-vegetale.png'),
          srcImage: require('./assets/680x680/hummus-vegetale.png')
        },
        {
          name:"Mozzarella",
          index: 'mozzarella',
          bgImage: require('./assets/sfondi-piatti/sfondo-mozzarella.png'),
          thumbImage: require('./assets/130x130/mozzarella.png'),
          srcImage: require('./assets/680x680/mozzarella.png')
        },
        {
          name:"Prosciutto",
          index: 'prosciutto',
          bgImage: require('./assets/sfondi-piatti/sfondo-prosciutto.png'),
          thumbImage: require('./assets/130x130/prosciutto.png'),
          srcImage: require('./assets/680x680/prosciutto.png')
        },
        {
          name:"Veggie meatballs",
          index: 'polpette-vegetali',
          bgImage: require('./assets/sfondi-piatti/sfondo-polpette-vegetali.png'),
          thumbImage: require('./assets/130x130/polpette-vegetali.png'),
          srcImage: require('./assets/680x680/polpette-vegetali.png')
        },
        {
          name:"Salad",
          index: 'insalata',
          bgImage: require('./assets/sfondi-piatti/sfondo-insalata.png'),
          thumbImage: require('./assets/130x130/insalata.png'),
          srcImage: require('./assets/680x680/insalata.png')
        },
        {
          name:"Oven-baked potatoes",
          index: 'patate-al-forno',
          bgImage: require('./assets/sfondi-piatti/sfondo-patate-al-forno.png'),
          thumbImage: require('./assets/130x130/patate-al-forno.png'),
          srcImage: require('./assets/680x680/patate-al-forno.png')
        },
        {
          name:"Zucchini",
          index: 'zucchine',
          bgImage: require('./assets/sfondi-piatti/sfondo-zucchine.png'),
          thumbImage: require('./assets/130x130/zucchine.png'),
          srcImage: require('./assets/680x680/zucchine.png')
        },
        {
          name:"Spinach",
          index: 'spinaci',
          bgImage: require('./assets/sfondi-piatti/sfondo-spinaci.png'),
          thumbImage: require('./assets/130x130/spinaci.png'),
          srcImage: require('./assets/680x680/spinaci.png')
        },
        {
          name:"Pineapple",
          index: 'ananas',
          bgImage: require('./assets/sfondi-piatti/sfondo-ananas.png'),
          thumbImage: require('./assets/130x130/ananas.png'),
          srcImage: require('./assets/680x680/ananas.png')
        },
        {
          name:"Orange",
          index: 'arancia',
          bgImage: require('./assets/sfondi-piatti/sfondo-arancia.png'),
          thumbImage: require('./assets/130x130/arancia.png'),
          srcImage: require('./assets/680x680/arancia.png')
        },
        {
          name:"Apple",
          index: 'mela',
          bgImage: require('./assets/sfondi-piatti/sfondo-mela.png'),
          thumbImage: require('./assets/130x130/mela.png'),
          srcImage: require('./assets/680x680/mela.png')
        },
        {
          name:"Pear",
          index: 'pera',
          bgImage: require('./assets/sfondi-piatti/sfondo-pera.png'),
          thumbImage: require('./assets/130x130/pera.png'),
          srcImage: require('./assets/680x680/pera.png')
        }
      ]

 